import { render, staticRenderFns } from "./ScenarioWindowFootnote.vue?vue&type=template&id=57fa4636&scoped=true"
import script from "./ScenarioWindowFootnote.vue?vue&type=script&lang=ts"
export * from "./ScenarioWindowFootnote.vue?vue&type=script&lang=ts"
import style0 from "./ScenarioWindowFootnote.vue?vue&type=style&index=0&id=57fa4636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa4636",
  null
  
)

export default component.exports